import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { FlyoutDataType, FlyoutOpeningData, PersonDetails, SessionDetails, VisitGoal } from '../flyout-models';
import { Subscription } from 'rxjs';
import { FlyoutService } from '../flyout.service';

@Component({
  selector: 'app-flyout-goals',
  templateUrl: './flyout-goals.component.html',
  styleUrls: ['./flyout-goals.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutGoalsComponent implements OnInit, OnDestroy {
  private readonly logger: Logger;
  private flyoutOpeningData: FlyoutOpeningData;
  private openingDataSubscription: Subscription;
  public personDetails: PersonDetails;
  private personSubscription: Subscription;
  private sessionDetails: SessionDetails;
  private sessionSubscription: Subscription;
  private subscriptionArray: Subscription[] = [];
  public dataEntries = [] as Array<VisitGoal>;
  public entriesToShow: Array<VisitGoal>;
  public sortingProperty = 'name';
  public sortingDirection = -1;
  public index = 0;
  public spanStart: number;
  public spanEnd: number;
  public expandedTab: string;

  constructor(
    public readonly loggerFactory: LoggerFactory,
    private readonly flyoutService: FlyoutService,
  ) {
    this.logger = loggerFactory.get('FlyoutCampaignInformationComponent');
  }

  ngOnInit() {
    this.openingDataSubscription = this.flyoutService.flyoutOpeningDataBS.subscribe(
      (flyoutOpeningData: FlyoutOpeningData) => {
        this.flyoutOpeningData = flyoutOpeningData;
        this.expandedTab = this.flyoutOpeningData?.expandedTab;
      },
    );
    this.sessionSubscription = this.flyoutService.sessionDetailsBS.subscribe((sessionDetails: SessionDetails) => {
      this.sessionDetails = sessionDetails;
    });
    this.personSubscription = this.flyoutService.personDetailsBS.subscribe((personDetails: PersonDetails) => {
      this.personDetails = personDetails;
    });
    this.processStatistics();
    this.slicePageOfGoals();
  }

  private slicePageOfGoals(): void {
    this.spanStart = this.index + 1;
    this.spanEnd = this.index + 5;
    this.entriesToShow = this.dataEntries.slice(this.index, this.index + 5);
  }

  private processStatistics() {
    if (this.flyoutOpeningData && this.flyoutOpeningData.type === FlyoutDataType.Contact && this.personDetails) {
      this.dataEntries = this.personDetails.goals;
    } else if (
      this.flyoutOpeningData &&
      this.flyoutOpeningData.type === FlyoutDataType.Session &&
      this.sessionDetails
    ) {
      this.dataEntries = this.sessionDetails.goals;
    } else {
      this.dataEntries = [];
    }
  }

  public sortByProperty(property: string) {
    if (property === this.sortingProperty) {
      this.sortingDirection = -1 * this.sortingDirection;
    }
    this.sortingProperty = property;
    this.dataEntries.sort((a, b) => {
      return a[property] > b[property] ? this.sortingDirection * 1 : this.sortingDirection * -1;
    });
    this.index = 0;
    this.slicePageOfGoals();
  }

  public navigateGoals(add: boolean) {
    if (add && this.index < this.dataEntries.length - 5) {
      this.index = this.index + 5;
    } else if (!add && this.index > 0) {
      this.index = this.index - 5;
    } else {
      return;
    }
    this.spanStart = this.index + 1;
    if (this.index < this.dataEntries.length - 5) {
      this.spanEnd = this.index + 5;
    } else {
      this.spanEnd = this.dataEntries.length;
    }
    this.entriesToShow = this.dataEntries.slice(this.index, this.index + 5);
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.openingDataSubscription, this.personSubscription, this.sessionSubscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
